import { hooks } from '@wove/react';
import { useRef } from 'react';

type Options<T> = {
  value?: T;
  defaultValue?: T;
  onChange?: (v: T) => void;
  valueList: T[];
};

export function usePropsListActiveValueChange<T>(option: Options<T>) {
  const { onChange, valueList } = option;
  const forceUpdate = hooks.useForceUpdate();
  const value = option.value !== undefined && valueList.includes(option.value) ? option.value : undefined;
  const defaultValue =
    option.defaultValue !== undefined && valueList.includes(option.defaultValue)
      ? option.defaultValue
      : valueList[0];
  const stateRef = useRef<T>(value !== undefined ? value : defaultValue);

  if (value !== undefined) {
    stateRef.current = value;
  }

  if (!valueList.includes(stateRef.current)) {
    stateRef.current = valueList[0];
  }

  const setState = hooks.useCallbackRef((v: T) => {
    if (value === undefined) {
      stateRef.current = v;
      forceUpdate();
    }
    onChange?.(v);
  });
  return [stateRef.current, setState] as const;
}
